
import { AppService } from "app/services/app.service";
import { Observable } from "rxjs";

export abstract class AbLocale extends AppService {

  abstract getLocales(): Observable<any>;
  abstract getLocaleIntegrador(): Observable<any>;
  abstract getLocaleUsuario(): Observable<any>;
  abstract getLocaleUsuarioOrIntegrador(): Observable<any>;
  abstract alterarLocaleUsuario(locale): Observable<any>;
}